/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_healthCheackResponse } from '../models/api_healthCheackResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Healthcheck {
    /**
     * Basic db and api health check
     * @returns api_healthCheackResponse OK
     * @throws ApiError
     */
    public static healthCheck(): CancelablePromise<api_healthCheackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/healthcheck',
            errors: {
                503: `Service Unavailable`,
            },
        });
    }
}
